module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-white-e90ef87f.png";